export default "__VITE_ASSET__$TPNGJfk__"